export { default as GDMList } from './GDMList';

export type { GDMListComponent, GDMListProps } from './GDMList.type';
